export { default } from "./FilterOptionLabel";
